import { DEFAULT_PRODUCT_SORT_OPTION, DbProductOverview, SortType, getSortByOptions } from '../../../models/Product';
import { ProductFilterState } from './types';

export const getDefaultProductFilterState = () => {
    const defaultProductFilterState: ProductFilterState = {
        searchText: "",
        generalAvailabilityOnly: false,
        productTypeState: [
            {
                label: "Boosters",
                data: "Booster"
            },
            {
                label: "Booster Boxes",
                data: "Booster Box"
            },
            {
                label: "Prerelease Kit",
                data: "Prerelease Kit"
            },
            {
                label: "Organized Play",
                data: "Organized Play Reward"
            },
            {
                label: "Fan Event Gifts",
                data: "Fan Event Gift"
            },
            {
                label: "Starter Decks",
                data: "Starter Deck"
            },
            {
                label: "Other",
                data: "Other"
            }
        ],
        sortByState: DEFAULT_PRODUCT_SORT_OPTION
    }

    return defaultProductFilterState;
}

export function applyProductFilters<T extends DbProductOverview>(items: T[], filterState: ProductFilterState): T[] {
    const matchingItems: T[] = [];
    const checkedProductTypes = filterState.productTypeState.filter(x => x.isChecked);

    for (const item of items) {
        let isMatch = true;

        let isProductTypeMatch = false;
        for (const checked of checkedProductTypes) {
            isProductTypeMatch = isProductTypeMatch || (checked.data != undefined && item.productType === checked.data);
        }

        isMatch = isMatch && (!filterState.productTypeState.some(x => x.isChecked) || isProductTypeMatch);

        if (filterState.searchText) {
            const lowerCaseSearchText = filterState.searchText.toLowerCase();
            isMatch = isMatch && item.name.toLocaleLowerCase().includes(lowerCaseSearchText);
        }

        if (filterState.generalAvailabilityOnly) {
            isMatch = isMatch && !!item.generallyAvailable;
        }

        if (!isMatch) {
            continue;
        }

        matchingItems.push(item);
    }
    
    return sortProducts<T>(matchingItems, filterState.sortByState.value);
}

export function sortProducts<T extends DbProductOverview>(items: T[], sortType: SortType | undefined): T[] {
    return items.sort((a, b) => {
        switch (sortType) {
            case "Name (Asc)":
                return a.name < b.name ? -1 : 1;
            case "Name (Desc)":
                return a.name > b.name ? -1 : 1;
            case "Release Date (Asc)":
                return (new Date(a.released)).getTime() < (new Date(b.released)).getTime() ? -1 : 1;
            case "Release Date (Desc)":
                return (new Date(a.released)).getTime() > (new Date(b.released)).getTime() ? -1 : 1;
            default:
                return (new Date(a.released)).getTime() > (new Date(b.released)).getTime() ? -1 : 1;
        }
    });
}